var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({class:['zg-button-link', {
    'zg-button-link--full-width': _vm.buttonProps && _vm.buttonProps.fullWidth,
    'zg-button-link--full-width-mobile': _vm.buttonProps && _vm.buttonProps.fullWidthMobile
  }],attrs:{"href":_vm.href}},'a',_vm.$attrs,false),[_c('zg-button',_vm._b({},'zg-button',_vm.buttonProps,false),[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }